import { Divider, Stack, Typography } from "@mui/material";

import messages from "../../../../../constants/messages";
import { useScimWizardContext } from "../../../../../providers/ScimWizardProvider";
import ScimWizardConfirmList from "../ScimWizardConfirmList";
import { ScimWizardStepContainer } from "../styled/scim-wizard.styled";
	
export default function Step7() {
	const { mappedRoles, mappedGroups, identityProviderName } = useScimWizardContext();

	const groupsWithMappings = Object.keys(mappedGroups).filter(group => mappedGroups[group].length > 0);
	const groupsWithoutMappings = Object.keys(mappedGroups).filter(group => mappedGroups[group].length === 0);
	const rolesWithMappings = Object.keys(mappedRoles).filter(role => mappedRoles[role].length > 0);
	const rolesWithoutMappings = Object.keys(mappedRoles).filter(role => mappedRoles[role].length === 0);

	return (
		<ScimWizardStepContainer spacing={4}>
			<Typography variant="h5">Confim Setup</Typography>
			<Typography variant="body1">{messages.SCIM_CONFIRM_SETUP_MSG(identityProviderName)}</Typography>
			<Stack direction="row" spacing={4} height={{ xxl: "445px", lg: "350px" }}>
				<ScimWizardConfirmList
					mapped={rolesWithMappings}
					unmapped={rolesWithoutMappings}
					resource="Roles"
				/>
				<Divider orientation="vertical" flexItem height="100%" />
				<ScimWizardConfirmList
					mapped={groupsWithMappings}
					unmapped={groupsWithoutMappings}
					resource="Groups"
				/>
			</Stack>
		</ScimWizardStepContainer>
	);
}